import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import {
  urlArticle,
  urlArticleSecured,
  urlGetAllArticleSecured,
} from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_ARTICLE,
  GET_ARTICLE,
  UPDATE_ARTICLE,
  DELETE_ARTICLE,
  FILTER_ARTICLE,
} from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.code !== undefined) filter += "&code=" + filters.code;
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.varietyUuid !== undefined)
      filter += "&varietyUuid=" + filters.varietyUuid;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

const generateFilterQueryAll = ({ filters }) => {
  let filter = "?";

  if (filters) {
    if (filters.code !== undefined) filter += "&code=" + filters.code;
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.varietyUuid !== undefined)
      filter += "&varietyUuid=" + filters.varietyUuid;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
  }

  return filter;
};

/**
 * Get Article by uuid.
 */
export const getArticleByUuid = createAction(GET_ARTICLE, (param) =>
  apiGet(urlArticleSecured, param, true)()
);

/**
 * Filter list Article.
 */
export const filterArticle = createAction(FILTER_ARTICLE, (filter, param) =>
  apiGet(urlArticleSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create Article.
 */
export const createArticle = createAction(CREATE_ARTICLE, (obj) =>
  apiPost(urlArticleSecured, obj, undefined, true)()
);

/**
 * Update Article.
 */
export const modifyArticle = createAction(UPDATE_ARTICLE, (obj, param) =>
  apiPut(urlArticleSecured, obj, param, true)()
);

/**
 * Delete Article by uuid.
 */
export const removeArticle = createAction(DELETE_ARTICLE, (param) =>
  apiDelete(urlArticleSecured, param, true)()
);

/**
 * Filter list article.
 */
export const getAll = createAction("GET_ALL_ARTICLES", (filters) =>
  apiGet(
    urlGetAllArticleSecured + generateFilterQueryAll(filters),
    undefined,
    false
  )()
);
